import unhead_KgADcZ0jPj from "/var/www/pecom.am/www/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/pecom.am/www/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/pecom.am/www/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/var/www/pecom.am/www/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/www/pecom.am/www/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/pecom.am/www/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/var/www/pecom.am/www/frontend/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/var/www/pecom.am/www/frontend/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/var/www/pecom.am/www/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/pecom.am/www/frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_AUP22rrBAc from "/var/www/pecom.am/www/frontend/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import vue_dompurify_html_dkB45ZSnPU from "/var/www/pecom.am/www/frontend/plugins/vue-dompurify-html.js";
import maska_r8BHBbSmHt from "/var/www/pecom.am/www/frontend/plugins/maska.js";
import routesPiniaInit_fn8sWidGJv from "/var/www/pecom.am/www/frontend/plugins/routesPiniaInit.js";
import vue_awesome_paginate_l1b0wTlGPB from "/var/www/pecom.am/www/frontend/plugins/vue-awesome-paginate.js";
import vue_datepicker_65xHnOJJH3 from "/var/www/pecom.am/www/frontend/plugins/vue-datepicker.js";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_AUP22rrBAc,
  vue_dompurify_html_dkB45ZSnPU,
  maska_r8BHBbSmHt,
  routesPiniaInit_fn8sWidGJv,
  vue_awesome_paginate_l1b0wTlGPB,
  vue_datepicker_65xHnOJJH3
]